<script>
  import { ListGroupItem, Alert, Row, Col } from "sveltestrap";

  import { beforeUpdate, afterUpdate, onMount } from "svelte";

  import Autolinker from "autolinker";

  import DOMPurify from "dompurify";

  import moment from "moment";

  export let chat;
  export let userName;

  let div;
  let autoscroll;
  let focus = true;
  let showNotifs = false;

  window.onfocus = () => (focus = true);
  window.onblur = () => (focus = false);

  beforeUpdate(() => {
    autoscroll =
      div && div.offsetHeight + div.scrollTop > div.scrollHeight - 150;
  });

  afterUpdate(() => {
    if (autoscroll) div.scrollTo(0, div.scrollHeight);
    if (!focus && chat.messages[chat.messages.length - 1].user !== userName) {
      new Notification(
        `New message from ${chat.messages[chat.messages.length - 1].user}`,
        {
          body: chat.messages[chat.messages.length - 1].message,
          icon: "/favicon.png"
        }
      );
    }
  });

  onMount(() => {
    div.scrollTo(0, div.scrollHeight);
  });
</script>

<style>

</style>

<ul
  class="list-group list-group-flush overflow-auto flex-grow-1 mb-4"
  style="border-radius: 0.25rem; overflow-x: hidden !important;"
  bind:this={div}>
  <Row>
    <Col sm="6">
      <Alert color="danger">
        Please remember: this chat will NOT be automatically deleted. A party
        member must press the delete button or else the contents of this chat
        will continue to exist!
      </Alert>
    </Col>
    <Col sm="6">
      <Alert color="success">
        To invite others to your chat, press the green share button. This will
        copy the room code to your clipboard!
      </Alert>
    </Col>
  </Row>
  {#each chat.messages as msg, i}
    {#if msg.user === userName}
      <ListGroupItem active class="p-2">
        {#if (i > 0 && chat.messages[i - 1].user !== msg.user) || i === 0}
          <div class="d-flex w-100 justify-content-between">
            <h6 class="mb-1">{msg.user}</h6>
            <small>{moment(msg.time.toDate()).format('h:mm')}</small>
          </div>
        {/if}
        {@html DOMPurify.sanitize(
          Autolinker.link(msg.message, {
            className: 'text-body'
          }),
          { ADD_ATTR: ['target'] }
        )}
      </ListGroupItem>
    {:else}
      <ListGroupItem color="dark" class="p-2">
        {#if (i > 0 && chat.messages[i - 1].user !== msg.user) || i === 0}
          <div class="d-flex w-100 justify-content-between">
            <h6 class="mb-1">{msg.user}</h6>
            <small>{moment(msg.time.toDate()).format('h:mm')}</small>
          </div>
        {/if}
        {@html DOMPurify.sanitize(
          Autolinker.link(msg.message, {
            className: 'text-primary'
          }),
          { ADD_ATTR: ['target'] }
        )}
      </ListGroupItem>
    {/if}
  {/each}
</ul>
